export const environment = {
  production: true,
  api: {
    url: 'https://agricaph.com.br/v1/',
  },
  folder: {
    images: 'assets/images'
  }
};
